import {Cookies} from "react-cookie";

export const headers = (projectId: string | undefined)=> {
    return {
        "x-auth-token": new Cookies().get("token"),
        "x-project": projectId,
        accept: "application/json"
    }
}